import { House, UserRound } from "lucide-react";
import { useTranslation } from "react-i18next";
import { usePrescriptionExitToStart } from "../context";
import { KioskStep } from "../../../../../components/kiosk-step";
import { KioskStatePanel } from "../../../../../components/kiosk-state-panel";

/**
 * Reception handoff shown after a stale manual-prescription policy rejection:
 * one content-sized panel (SPK-04) with a 56px "Zurück zum Start" that leaves
 * the flow (KO-17, FB-31).
 *
 * @since 1.2.0
 * @example
 * ```tsx
 * <ManualPrescriptionHandoffStep />
 * ```
 */
export function ManualPrescriptionHandoffStep() {
  const { t } = useTranslation();
  const exitToStart = usePrescriptionExitToStart();

  return (
    <KioskStep width="narrow" align="center" title={t("self-service.help-reception")}>
      <KioskStatePanel
        tone="info"
        testId="frontdesk-prescription-manual-policy-handoff"
        icon={<UserRound />}
        title={t("self-service.help-reception")}
        body={t("self-service.help-reception-toast")}
        action={{
          label: t("self-service.prescription.no-patient.back-home"),
          icon: House,
          onClick: exitToStart,
          testId: "frontdesk-prescription-manual-handoff-done-btn",
        }}
      />
    </KioskStep>
  );
}
